import {Skeleton, Stack} from '@travel-frontend/ui-components';

type Props = {
  count: number;
  kind: 'group' | 'stream';
};

export const Tile = ({count, kind}: Props) => (
  <Stack spacing={0.75}>
    <Skeleton variant="text" width="7.5rem" height="2rem" />
    <div>
      {Array.from({length: count}, (_, index: number) => (
        <Skeleton
          key={index}
          variant="text"
          height="1.5rem"
          width={kind === 'stream' ? '3rem' : undefined}
        />
      ))}
    </div>
  </Stack>
);
